import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/manual-quote-items*`. Types mirror @penn/shared-types
// ManualQuoteItem (kept local per the existing api/*.ts convention).
// `price` is a decimal STRING (§D.12); `id` is a server-owned UUID.

export interface ManualQuoteItem {
  id: string;
  isManual: boolean | null;
  label: string | null;
  partNo: string | null;
  description: string | null;
  category: string | null;
  toolingType: string | null;
  machineType: string | null;
  itemName: string | null;
  partName: string | null;
  currency: string | null;
  price: string | null;
  qty: number | null;
}

export interface ManualQuoteItemList {
  data: ManualQuoteItem[];
  total: number;
}

/** POST body — `id` is NEVER sent (server-generated). */
export interface CreateManualQuoteItemBody {
  isManual?: boolean;
  label?: string | null;
  partNo?: string | null;
  description: string;
  category?: string | null;
  toolingType?: string | null;
  machineType?: string | null;
  itemName?: string | null;
  partName?: string | null;
  currency: string;
  price: string | number;
  qty: number;
}

export type UpdateManualQuoteItemBody = Partial<CreateManualQuoteItemBody>;

const BASE = "/v1/manual-quote-items";

/** GET /v1/manual-quote-items — all active records. */
export async function listManualQuoteItems(): Promise<ManualQuoteItemList> {
  const res = await Api.get(BASE);
  return unwrap<ManualQuoteItemList>(res.data);
}

/** POST /v1/manual-quote-items. */
export async function createManualQuoteItem(
  body: CreateManualQuoteItemBody,
): Promise<ManualQuoteItem> {
  const res = await Api.post(BASE, body);
  return unwrap<ManualQuoteItem>(res.data);
}

/** PATCH /v1/manual-quote-items/:id. */
export async function updateManualQuoteItem(
  id: string,
  body: UpdateManualQuoteItemBody,
): Promise<ManualQuoteItem> {
  const res = await Api.patch(`${BASE}/${encodeURIComponent(id)}`, body);
  return unwrap<ManualQuoteItem>(res.data);
}

/** DELETE /v1/manual-quote-items/:id (soft-delete). */
export async function deleteManualQuoteItem(id: string): Promise<void> {
  await Api.delete(`${BASE}/${encodeURIComponent(id)}`);
}
